import React from 'react';
import Context from './context';
import HeroBgImage from '../../../images/features/jtb/hero-bg.jpg';
import HeroTitleImage from '../../../images/features/jtb/hero-title.png';
import { makeBackgroundImageStyles } from '../../core/styles';
import HeroSakeImage from '../../../images/features/jtb/hero-sake.png';
import HeroVegeImage from '../../../images/features/jtb/hero-vege.png';
import HeroLineImage from '../../../images/features/jtb/hero-line.png';
import HeroLineBgImage from '../../../images/features/jtb/hero-line-bg.png';
import Grid from '@material-ui/core/Grid';

const Hero = () => {
  const { classes } = React.useContext(Context);

  return (
    <div
      style={makeBackgroundImageStyles(HeroBgImage)}
      className={classes.heroRoot}
    >
      <div className={classes.heroWrapper}>
        <div className={classes.heroBox}>
          <div className={classes.heroMainBox}>
            <img src={HeroTitleImage} />
          </div>
          <Grid container justify="center" className={classes.heroGrid}>
            <Grid
              item
              container
              alignItems="flex-end"
              className={classes.heroFirstGrid}
            >
              <Grid item xs={6} style={{ textAlign: 'left' }}>
                <img src={HeroSakeImage} className={classes.heroLeftImg} />
              </Grid>
              <Grid item xs={6} style={{ textAlign: 'right' }}>
                <img src={HeroVegeImage} className={classes.heroRightImg} />
              </Grid>
            </Grid>
            <Grid item xs={12} className={classes.heroJointGrid}>
              <picture>
                <source srcSet={HeroLineImage} media="(max-width: 700px)" />
                <img src={HeroLineBgImage} />
              </picture>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
};

export default Hero;
